// extracted by mini-css-extract-plugin
export var backupIcon = "_t3-1";
export var image = "_t3-0";